<template lang="pug">
  include ./../../vuek/mixins.pug

  +b.the-compare-section
    t-section
      t-h2 {{content.header2}}
      //- t-h3 послідовність згідно рейтингу 2017 року
      +e.chart
          t-radar-chart(
            :dataSet="dataToDisplay"
            :cfg="radarChartOptions",
            :short="false"
          )
      +e.container
        +e.select._second
          v-select(
            v-model="firstCountry",
            :options="countries"
          )
        +e.select._first
          v-select(
            v-model="secondCountry",
            :options="countries"
          )
</template>

<script>
import { mapGetters } from 'vuex';
import vSelect from 'vue-select';

import TSection from '@/components/TSection/TSection';
import TH2 from '@/components/TH2/TH2';
import TH3 from '@/components/TH3/TH3';
import TRadarChart from '@/components/TIRadarChart/TIRadarChart';

import d3 from './../../tools/d3/d3';

export default {
  name: 'the-compare-section',

  data() {
    return {
      testData: [
        [
          {
            axis: 'test1',
            value: 0.1,
          },
          {
            axis: 'test2',
            value: 30,
          },
          {
            axis: 'test3',
            value: 80,
          },
          {
            axis: 'test4',
            value: 10,
          },
          {
            axis: 'test5',
            value: 10,
          },
        ],
        [
          {
            axis: 'test1',
            value: 10,
          },
          {
            axis: 'test2',
            value: 50,
          },
          {
            axis: 'test3',
            value: 10,
          },
          {
            axis: 'test4',
            value: 50,
          },
          {
            axis: 'test5',
            value: 20,
          },
        ],
      ],

      radarChartOptions: {
        // Width of the circle
        w: 400,
        // Height of the circle
        h: 400,
        // The margins of the SVG
        margin: {
          top: 100,
          right: 100,
          bottom: 100,
          left: 100,
        },
        // How many levels or inner circles should there be drawn
        levels: 5,
        // What is the value that the biggest circle will represent
        maxValue: 100,
        // How much farther than the radius of the outer circle should the labels be placed
        labelFactor: 1.25,
        // The number of pixels after which a label needs to be given a new line
        wrapWidth: 60,
        // The opacity of the area of the blob
        opacityArea: 0.35,
        // The size of the colored circles of each blog
        dotRadius: 4,
        // The opacity of the circles of each blob
        opacityCircles: 0.1,
        // The width of the stroke around each blob
        strokeWidth: 2,
        // If true the area and stroke will follow a round path (cardinal-closed)
        roundStrokes: true,
        // Color function
        color: d3.scaleOrdinal(d3.schemeCategory10),
      },

      firstCountry: 'Нова Зеландія',
      secondCountry: 'Україна',
    };
  },

  computed: {
    countries() {
      const countries = [];

      for (let i = 0; i < this.dataSet.length; i += 1) {
        countries.push(this.dataSet[i].name_ua);
      }

      return countries.sort();
    },

    dataToDisplay() {
      const firstCountry = this.dataSet.find(item => item.name_ua === this.firstCountry);
      const secondCountry = this.dataSet.find(item => item.name_ua === this.secondCountry);
      const parameters1 = [];
      const parameters2 = [];

      for (let i = 0; i < firstCountry.indicators.length; i += 1) {
        if (firstCountry.indicators[i].y17 && secondCountry.indicators[i].y17) {
          parameters1.push({
            axis: firstCountry.indicators[i].name,
            value: firstCountry.indicators[i].y17,
          });
          parameters2.push({
            axis: firstCountry.indicators[i].name,
            value: secondCountry.indicators[i].y17,
          });
        }
      }

      return [parameters1, parameters2];
    },

    ...mapGetters({
      dataSet: 'allDataSet',
      content: 'getContent',
      lng: 'lng',
    }),
  },

  components: {
    TSection,
    TH2,
    TH3,
    TRadarChart,
    vSelect,
  },
};
</script>


<style lang="scss">
@import '../../scss/styles';

.the-compare-section {
  position: relative;
  width: 100%;
  background-color: $color-white;
  border-top: 1px solid white;
  border-bottom: 1px solid white;

  &__container {
    display: flex;
    width: 100%;
    align-items: center;
  }

  &__select {
    margin: 0 16px;
    width: calc((100% - 32px) / 2);

    &_first .v-select .dropdown-toggle {
      border: 1px solid rgba(255,127,14,.40);
    }

    &_second .v-select .dropdown-toggle {
      border: 1px solid rgba(31,119,180,.40);
    }

    & .clear {
      display: none;
    }
  }

  &__chart {
    width: 600px;
    height: 600px;
    margin: 0 auto 48px;

  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheCompareSection/TheCompareSection.vue